import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	button: {
		paddingLeft: "10px",
		paddingRight: "15px",
		paddingTop: "10px",
		paddingBottom: "12px",
		minHeight: "48px",
		borderLeft: "3px solid transparent",
		gap: "10px",
		overflow: "hidden",
		cursor: "pointer",
		width: "100%",
		"&:hover": {
			backgroundColor: colors.gray[100]
		}
	},
	buttonCollapsed: {
		paddingLeft: 0,
		paddingRight: 0,
		justifyContent: "center",
		borderLeft: "none"
	},
	avatarCircle: {
		width: "36px",
		height: "36px",
		minWidth: "36px",
		borderRadius: "50%",
		backgroundColor: colors.gray[0],
		border: `1px solid ${colors.purple[100]}`,
		flexShrink: 0,
		color: colors.purple[600]
	},
	textBlock: {
		flex: 1,
		minWidth: 0,
		overflow: "hidden"
	},
	nameText: {
		fontSize: "13px",
		color: colors.gray[800],
		fontWeight: 500,
		lineHeight: 1.3,
		marginBottom: "2px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	emailText: {
		fontSize: "11px",
		color: colors.gray[500],
		lineHeight: 1.2,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	chevronIcon: {
		flexShrink: 0,
		color: colors.purple[100]
	},
	popperPaper: {
		maxHeight: "calc(100vh - 100px)",
		overflowY: "auto",
		width: "250px",
		background: colors.gray[0],
		border: `1px solid ${colors.gray[100]}`
	},
	listItemIcon: {
		minWidth: "40px",
		color: colors.gray[700]
	},
	itemTextTypography: {
		fontSize: "13px",
		color: colors.gray[800]
	},
	styledSubLink: {
		textDecoration: "none",
		color: "inherit"
	},
	popperContainer: {
		zIndex: 1300
	},
	disabledItem: {
		opacity: 0.5,
		"& .Mui-disabled": {
			opacity: "1 !important"
		}
	},
	disabledInfoIcon: {
		display: "flex",
		alignItems: "center",
		marginRight: "16px"
	}
})

export default useStyles
